

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import ToastPlugin from 'vux/src/plugins/toast/index.js'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import CryptoJS from 'crypto-js'


Vue.prototype.ajax=$.ajax;
Vue.prototype.$=$;
Vue.use(DatetimePlugin);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.directive('transfer-dom', TransferDom);

Vue.config.productionTip = false;
Vue.prototype.getCookie=function (cookie_name) {
let allcookies = document.cookie;
let cookie_pos = allcookies.indexOf(cookie_name);   
let value="";
if (cookie_pos != -1) {
cookie_pos += cookie_name.length + 1;      
let cookie_end = allcookies.indexOf(";", cookie_pos);
if (cookie_end == -1) {cookie_end = allcookies.length;}
value = unescape(allcookies.substring(cookie_pos, cookie_end));         
}
return value;
}
$.ajaxSetup({
crossDomain: true,
xhrFields: {
withCredentials: true
},
});
/**新加**/
Vue.prototype.jusewebapp="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/";

Vue.prototype.Exp={
password:new RegExp(/^[a-zA-Z]\w{5,19}$/),//字母数字下划线
phoneNum:/^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[0-9])[0-9]{8}$/,//手机号
userName:/^[A-Za-z0-9\u4e00-\u9fa5]+$/,//用户名
phone: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\s?\d{4}\s?\d{4}$/,
phone1: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
ID: /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/,
};
if(process.env.NODE_ENV=="production"){
/**新加**/
Vue.prototype.doctorLogin="https://passport.gooeto.com";
Vue.prototype.imgUpload="https://bms.gooeto.com/fileAPI/bannerImg";
Vue.prototype.doctor="https://doctor.gooeto.com";
Vue.prototype.hospital='https://m.gooeto120.com/'
Vue.prototype.gytH5 = 'https://spread.gooeto120.net/gyt/gytjiankang-h5'; 
}else{
/**新加**/
Vue.prototype.doctorLogin="https://passportnew.gooeto.com";
Vue.prototype.imgUpload="https://bmstest.gooeto.com/fileAPI/bannerImg";
Vue.prototype.doctor="https://doctortest.gooeto.com";
Vue.prototype.hospital='https://strong.ylccmp.com/'
Vue.prototype.gytH5 = 'https://judaotest.gooeto.com/gyt/normal';
}
let share=function (title,desc,imgUrl){
console.log(title, desc, imgUrl);
$.get(Vue.prototype.healthyDay+'/webApi/wxShare',{shareUrl:(location.href.split('#')[0])},(res1)=>{
let res=JSON.parse(res1);
console.log("分享调用");
if(res.code==200){
console.log("分享函数调用成功");
wx.config({
debug: false,
appId: res.data.appID,
timestamp: res.data.timestamp,
nonceStr: res.data.noncestr,
signature: res.data.signature,
jsApiList: [
'onMenuShareTimeline',       // 分享到朋友圈接口
'onMenuShareAppMessage',  //  分享到朋友接口
'onMenuShareQQ',         // 分享到QQ接口
'onMenuShareWeibo',      // 分享到微博接口
],

});
}
wx.error(function (e) {
console.log('wx_error:' + JSON.stringify(e));
});
wx.ready(function(){
console.log(`wx.ready`)
let obj={
title, // 分享标题
desc, // 分享描述
link:res.data.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl,
type: '', // 分享类型,music、video或link，不填默认为link
dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
success: function (res) {
console.log(res+'分享成功')
},
cancel(res){
console.log(res+'分享取消')
}
};
wx.onMenuShareTimeline (obj);
wx.onMenuShareAppMessage (obj);
wx.onMenuShareQQ (obj);
wx.onMenuShareWeibo (obj);
});
})
};
Vue.prototype.share=share;
router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title
}
next()
});


Vue.prototype.getAesString=function (data, key='ppkjhtfetyhvdry6', iv='ppkjhtfetyhvdry6') {
var key = CryptoJS.enc.Utf8.parse(key);
var iv = CryptoJS.enc.Utf8.parse(iv);
var encrypted = CryptoJS.AES.encrypt(data, key, {
iv: iv,
mode: CryptoJS.mode.CBC,
padding: CryptoJS.pad.Pkcs7
});
return encrypted.ciphertext.toString(); 
}





















/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
});







// WEBPACK FOOTER //
// ./src/main.js